import { Flex, FormLabel } from '@chakra-ui/react';
import React from 'react';
import { DoneIcon } from '../../shared';
var features = [
    'Boost reviews and attract more customers',
    'Automate review and referral requests with smart follow-ups',
    'Monitor reviews in real time for quick action',
    'Seamless integration with other apps, and CRM tools',
];
var KeyFeatures = function () {
    return (React.createElement(Flex, { flexDir: 'column' },
        React.createElement(FormLabel, null, "Key features"),
        React.createElement(Flex, { flexDir: 'column', gap: 'sm' }, features.map(function (feature) { return (React.createElement(Flex, { key: feature, gap: 'sm' },
            React.createElement(DoneIcon, { mt: '3px', boxSize: 5, color: 'primary.pure' }),
            feature)); }))));
};
export default KeyFeatures;
//# sourceMappingURL=KeyFeatures.js.map